import { FormattedMessage } from 'react-intl';
import { MouseEventHandler } from 'react';
import { Tab as TabStyled } from './tabs.styles';
import { VisitUiType } from 'store/visits/types';

interface TabProps {
  type: VisitUiType;
  onClick?: MouseEventHandler;
}
export const Tab = ({ type, onClick }: TabProps): JSX.Element => {
  // const getClassName = useCallback((isActive: boolean) => (isActive ? 'active' : ''), []);

  return (
    <TabStyled
      // className={getClassName}
      to={type}
      end={false}
      data-cy={`${type}-visitors-tab`}
      data-testid={`${type}-visitors-tab`}
      onClick={onClick}
    >
      <FormattedMessage id={`labels.${type}`} />
    </TabStyled>
  );
};
